import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import './Legal.css';

const Terms: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="header-content">
          <button onClick={() => navigate(-1)} className="back-button">
            ← Back
          </button>
          <div className="brand-logo" onClick={() => navigate('/')}>
            <Logo height={34} />
          </div>
        </div>
      </header>

      <main className="legal-main">
        <article className="legal-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: December 2024</p>

          <section>
            <h2>Agreement to Terms</h2>
            <p>
              By accessing or using Lomi, you agree to be bound by these Terms of Service.
              If you disagree with any part of the terms, you may not access the service.
            </p>
          </section>

          <section>
            <h2>Description of Service</h2>
            <p>
              Lomi is an AI-powered tutoring platform designed to help Ethiopian students
              prepare for high-stakes examinations — currently the Ethiopian School Leaving
              Certificate Examination (ESSLCE) and the Addis Ababa University Undergraduate
              Admission Test (UAT). Our service includes:
            </p>
            <ul>
              <li>Interactive lessons aligned with the Ethiopian curriculum</li>
              <li>Practice questions from past ESSLCE examinations</li>
              <li>Preparation material for the AAU Undergraduate Admission Test (UAT)</li>
              <li>AI-powered tutoring and explanations</li>
              <li>Progress tracking and personalized learning paths</li>
            </ul>
          </section>

          <section>
            <h2>User Accounts</h2>
            <p>
              To use Lomi, you must create an account using your Ethiopian phone number.
              You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate information about your grade level and stream</li>
            </ul>
          </section>

          <section>
            <h2>Acceptable Use</h2>
            <p>You agree NOT to:</p>
            <ul>
              <li>Share your account with others</li>
              <li>Use Lomi for any unlawful purpose</li>
              <li>Attempt to extract or copy our content, questions, or AI systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Use automated systems to access the service without permission</li>
            </ul>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <p>
              All content on Lomi, including lessons, questions, explanations, and the
              AI tutoring system, is owned by Lomi or its licensors. You may not
              reproduce, distribute, or create derivative works without our permission.
            </p>
            <p>
              ESSLCE past examination questions are used for educational purposes.
              All rights to original examinations belong to the Ethiopian Ministry of Education.
            </p>
          </section>

          <section>
            <h2>Pricing</h2>
            <p>
              Lomi is currently free to use for all Ethiopian students. If we
              introduce paid features in the future, we will notify you in
              advance and existing users will continue to have access to
              their current functionality.
            </p>
          </section>

          <section>
            <h2>AI Tutoring Disclaimer</h2>
            <p>
              Lomi uses artificial intelligence to provide tutoring and explanations. While
              we strive for accuracy:
            </p>
            <ul>
              <li>AI responses are generated and may occasionally contain errors</li>
              <li>Lomi supplements but does not replace classroom instruction</li>
              <li>We do not guarantee specific exam results</li>
              <li>Students should verify important information with teachers or official sources</li>
            </ul>
          </section>

          <section>
            <h2>Service Availability</h2>
            <p>
              We aim to provide reliable service but cannot guarantee uninterrupted access.
              We may modify, suspend, or discontinue features with reasonable notice.
            </p>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by Ethiopian law, Lomi shall not be
              liable for any indirect, incidental, or consequential damages arising from
              your use of our service.
            </p>
          </section>

          <section>
            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of the Federal Democratic Republic
              of Ethiopia. Any disputes shall be resolved in the courts of Addis Ababa.
            </p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of
              Lomi after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              For questions about these Terms, contact us at:
            </p>
            <ul>
              <li>Email: <a href="mailto:info@lomistudy.com">info@lomistudy.com</a></li>
              <li>Location: Addis Ababa, Ethiopia</li>
            </ul>
          </section>
        </article>
      </main>

      <footer className="legal-footer">
        <div className="footer-brand">
          <Logo height={28} />
        </div>
      </footer>
    </div>
  );
};

export default Terms;
